import { useProcessesWithField } from 'charts/common/useProcessesWithField';
import { AnalyticsTranslationKeys } from 'intl/keys';
import { useCallback, useMemo } from 'react';
import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import {
  ChartType,
  IssueChart,
} from 'shared/types/analytics';
import { customAccessFunction } from '../common/access';
import { EMPTY_VALUES_AND_LABELS, useGetChart } from '../common/hooks';
import { mapValuesAndLabels } from '../model/mapSeriesToRawData';
import { IssueChartContext, useIssueChartFilters } from 'charts/common/issueChartFilters';

export function useHsEffect(): IssueChartContext {
  const processesWithHsEffect = useProcessesWithField(
    IssueFieldNames.effect
  );
  const access = useCallback(() => {
    return Boolean(processesWithHsEffect.length);
  }, [processesWithHsEffect]);

  const filters = useIssueChartFilters({ chart: IssueChart.hsEffect, processes: processesWithHsEffect });
  const additionalParams = useMemo(
    () => ({
      visibleProcesses: processesWithHsEffect.map(
        (process) => process._id
      ),
    }),
    [processesWithHsEffect]
  );

  const { series, loading, load, reload, updatedAt } =
    useGetChart({ chart: IssueChart.hsEffect, filters, additionalParams, initialSeries: EMPTY_VALUES_AND_LABELS });

  const rawData = useMemo(() => mapValuesAndLabels(series), [series]);

  return {
    filters,
    titleId: AnalyticsTranslationKeys.effectChart,
    chartType: ChartType.bar,
    canAccess: customAccessFunction(access),
    loading: !filters || loading,
    load,
    forceUpdate: reload,
    updatedAt: (): number => updatedAt,
    rawData,
  };
}
